import React from 'react';

import { Helpers } from '../Helpers';

export default function CartItem({ item, tour, onRemove, actions = [], price }) {

    const participantTiers = _.groupBy(item.participantList, 'tier.key');
    const unitTiers = _.groupBy(item.unitList, 'tier.key');
    const tiers = _.isEmpty(participantTiers) ? unitTiers : participantTiers;

    console.log("item", item)
    return (
        <div className="cart-item">
            <div className="row">
                <div className="col-12">
                    <div className="pr-1 border-top position-relative py-3">
                        {onRemove && 
                            <button 
                                onClick={() => onRemove(item.id, tour.id)}
                                className="btn position-absolute p-0 bg-white" style={{ right: '10px', top: '10px', zIndex: '100' }}>
                                    <i className="fa fa-lg fa-times-circle four-a-text"></i>
                            </button>                        
                        }

                        <div>
                            <div className="row form-row mb-2">
                                <div className="col-2 align-self-center">
                                    <img className="img-fluid" src={tour.cover_photo.small} />
                                </div>
                                <div className="col-10 align-self-center">
                                    <a className="font-large text-dark" href="#">
                                        {tour.name}
                                    </a>
                                </div>
                            </div>

                            <ul className="list-inline font-small mb-1 text-muted">
                                <li className="list-inline-item mr-3">
                                    <i className="far fa-fw fa-calendar-alt mr-1"></i>{Helpers.toDateString(item.date.startTime)}
                                </li>
                            </ul>
                            <div>
                                <div className="font-small text-muted mb-1">
                                    <i className="far fa-fw fa-user mr-1"></i>

                                    {
                                        
                                        Object.keys(tiers).map((key, i) => {
                                            const label = tiers[key][0].tier.label;
                                            return (
                                                <span key={key}>
                                                    {(i > 0 ? ", " : "") + tiers[key].length} <span>&times;</span> {label}
                                                </span>
                                            )
                                        })
                                    }
                                </div>
                            </div>

                            <ul className="list-inline font-small mb-1 text-muted">
                                <li className="list-item">
                                    <b>Pickup:</b> {Helpers.toTimeString(item.pickup.transferTimes.pickup)}
                                </li>
                                <li className="list-item">
                                    <b>Begins:</b> {Helpers.toTimeString(item.date.startTime)}
                                </li>
                                <li className="list-item">
                                    <b>Ends:</b> {Helpers.toTimeString(item.date.endTime)}
                                </li>
                                <li className="list-inline-item">
                                    <b>Returns:</b> {Helpers.toTimeString(item.pickup.transferTimes.dropoff)}
                                </li>
                            </ul>
                        </div>

                        
                        <div>
                            <div className="d-flex justify-content-between align-items-center mb-2 mt-2"> 
                                <div className="actions">
                                    {actions.map(({fire, icon, label, color }, index) => (
                                        <a 
                                            key={index}
                                            className={`${color || "primary-text"} font-small mr-4`}
                                            onClick={() => fire(tour, item)}
                                        >
                                            <i className={`${icon} mr-1`}></i>
                                            <span>{label}</span>
                                        </a>
                                    ))}
                                </div>                               
                                <div>
                                    <span className="font-weight-bold font-small">
                                        {price}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./resources/js/components/CartItem/index.js